import { combineReducers } from 'redux'

import initialState from 'app_modules/store/initialState.json'
import emailPreferencesActionTypes from 'app_modules/emailPreferences/constants'
import sessionActionTypes from 'app_modules/session/constants'

export const isFetching = (state = initialState.emailPreferences.isFetching, { type }) => {
  switch (type) {
    case emailPreferencesActionTypes.FETCH_EMAIL_PREFERENCES_REQUEST:
      return true

    case emailPreferencesActionTypes.FETCH_EMAIL_PREFERENCES_SUCCESS:
    case emailPreferencesActionTypes.FETCH_EMAIL_PREFERENCES_FAILURE:
      return false

    case sessionActionTypes.RESET_STATE:
      return initialState.emailPreferences.isFetching

    default:
      return state
  }
}

export const isUpdating = (state = initialState.emailPreferences.isUpdating, { type }) => {
  switch (type) {
    case emailPreferencesActionTypes.UPDATE_EMAIL_PREFERENCE_REQUEST:
    case emailPreferencesActionTypes.UNSUBSCRIBE_ALL_REQUEST:
      return true

    case emailPreferencesActionTypes.UPDATE_EMAIL_PREFERENCE_SUCCESS:
    case emailPreferencesActionTypes.UPDATE_EMAIL_PREFERENCE_FAILURE:
    case emailPreferencesActionTypes.UNSUBSCRIBE_ALL_SUCCESS:
    case emailPreferencesActionTypes.UNSUBSCRIBE_ALL_FAILURE:
      return false

    case sessionActionTypes.RESET_STATE:
      return initialState.emailPreferences.isUpdating

    default:
      return state
  }
}

export const preferences = (state = initialState.emailPreferences.preferences, { payload, type }) => {
  switch (type) {
    case emailPreferencesActionTypes.FETCH_EMAIL_PREFERENCES_SUCCESS:
      // ApiEndpoint converts all keys to camelCase — snake_case keys become camelCase.
      // email_preferences → emailPreferences, opted_in → optedIn, etc.
      return payload.emailPreferences || []

    case emailPreferencesActionTypes.UPDATE_EMAIL_PREFERENCE_SUCCESS:
      // Update the optedIn value for the matching category in the list.
      // Keys in state are already camelCase (converted by ApiEndpoint).
      return state.map(pref => (pref.category === payload.category ? { ...pref, optedIn: payload.optedIn } : pref))

    case emailPreferencesActionTypes.UNSUBSCRIBE_ALL_SUCCESS:
      // Opt out all non-transactional categories (transactional is always on).
      return state.map(pref => (pref.category === 'transactional' ? pref : { ...pref, optedIn: false }))

    case emailPreferencesActionTypes.FETCH_EMAIL_PREFERENCES_FAILURE:
    case sessionActionTypes.RESET_STATE:
      return initialState.emailPreferences.preferences

    default:
      return state
  }
}

export default combineReducers({
  isFetching,
  isUpdating,
  preferences,
})
